import { useEffect, useRef } from "react";

const useMetaTags = ({ title, description, ogImage }) => {
  const originals = useRef(null);

  if (!originals.current) {
    originals.current = {
      title: document.title,
      description: document.querySelector('meta[name="description"]')?.getAttribute("content") || "",
      ogTitle: document.querySelector('meta[property="og:title"]')?.getAttribute("content") || "",
      ogDescription: document.querySelector('meta[property="og:description"]')?.getAttribute("content") || "",
      ogImage: document.querySelector('meta[property="og:image"]')?.getAttribute("content") || "",
      ogUrl: document.querySelector('meta[property="og:url"]')?.getAttribute("content") || "",
      twitterTitle: document.querySelector('meta[name="twitter:title"]')?.getAttribute("content") || "",
      twitterDescription: document.querySelector('meta[name="twitter:description"]')?.getAttribute("content") || "",
      twitterImage: document.querySelector('meta[name="twitter:image"]')?.getAttribute("content") || "",
    };
  }

  useEffect(() => {
    const updateMeta = (selector, value) => {
      const el = document.querySelector(selector);
      if (el && value) el.setAttribute("content", value);
    };

    if (title) {
      document.title = `${title} | Narendra Modi Photo Gallery`;
      updateMeta('meta[property="og:title"]', `${title} | Narendra Modi Photo Gallery`);
      updateMeta('meta[name="twitter:title"]', `${title} | Narendra Modi Photo Gallery`);
    }

    if (description) {
      updateMeta('meta[name="description"]', description);
      updateMeta('meta[property="og:description"]', description);
      updateMeta('meta[name="twitter:description"]', description);
    }

    if (ogImage) {
      updateMeta('meta[property="og:image"]', ogImage);
      updateMeta('meta[name="twitter:image"]', ogImage);
    }

    updateMeta('meta[property="og:url"]', window.location.href);

    return () => {
      const orig = originals.current;
      if (!orig) return;

      document.title = orig.title;

      const restore = (selector, value) => {
        const el = document.querySelector(selector);
        if (el) el.setAttribute("content", value);
      };

      restore('meta[name="description"]', orig.description);
      restore('meta[property="og:title"]', orig.ogTitle);
      restore('meta[property="og:description"]', orig.ogDescription);
      restore('meta[property="og:image"]', orig.ogImage);
      restore('meta[property="og:url"]', orig.ogUrl);
      restore('meta[name="twitter:title"]', orig.twitterTitle);
      restore('meta[name="twitter:description"]', orig.twitterDescription);
      restore('meta[name="twitter:image"]', orig.twitterImage);
    };
  }, [title, description, ogImage]);
};

export default useMetaTags;
